import { minVisitsAbbrFilter, percentageSignFilter } from "app/filters/ngFilters";
import { ChangeTooltip } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";
import { Disclaimer } from "app/pages/industry-analysis/common/Disclaimer";

const Container = styled.div`
    padding: 0 16px 16px 16px;
    line-height: 20px;
`;

export const TooltipFormatter = (highChartRef) => {
    const point = highChartRef.points[0];
    const pointOptions = point.point.options;
    const { labelChange, displayText } = pointOptions;
    const { y, color } = point;
    const formatter = (value) => minVisitsAbbrFilter()(value);

    const tableRow = {
        value: formatter(y),
        color,
        displayName: displayText,
        change: percentageSignFilter()(labelChange, 2),
    };

    const changeTooltipProps = {
        tableHeaders: [
            {
                position: 0,
                displayName: translate("market.segmentation.size.growth.bar.char.tooltip.header.industry"),
            },
            {
                position: 1,
                displayName: translate("market.segmentation.size.growth.bar.char.tooltip.header.visits"),
            },
            {
                position: 2,
                displayName: translate("market.segmentation.size.growth.bar.char.tooltip.header.trend"),
            },
        ],
        tableRows: [tableRow],
    };

    const displayDisclaimer = point.point.index === 0;
    return (
        <Container>
            <ChangeTooltip {...changeTooltipProps}>
                {displayDisclaimer && (
                    <Disclaimer messageKey={"market.segmentation.size.growth.bar.char.tooltip.top.sites"} />
                )}
            </ChangeTooltip>
        </Container>
    );
};
